'use client';

import { useEffect } from 'react';

const FORM_REGISTRATION_CONST = {
  name: 'registration',
  key: 'wx.registrationForm',
  cookie: {
    registration: 'registered',
    hutk: 'hubspotutk',
  },
};

const getCookie = (name: string): string => {
  if (typeof document === 'undefined') return '';
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift() || '';
  return '';
};

const setCookie = (name: string, value: string, days: number): void => {
  if (typeof document === 'undefined') return;
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

const isFormRegistrationCookieSet = (): boolean => {
  return !!getCookie(FORM_REGISTRATION_CONST.cookie.registration);
};

const setFormRegistrationCookie = (): void => {
  setCookie(FORM_REGISTRATION_CONST.cookie.registration, 'true', 36500);
};

const insertHubspotScript = () => {
  if (document.getElementById('hs-script-loader')) return;
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = 'hs-script-loader';
  script.async = true;
  script.defer = true;
  script.src = '//js.hs-scripts.com/24433678.js'; // Production portal ID

  if (window.location.hostname === 'localhost') {
    script.src = '//js.hs-scripts.com/139584591.js'; // Sandbox portal ID
  }

  document.body.appendChild(script);
};

interface HubSpotUTKProps {
  shouldLoad?: boolean;
}

const HubSpotUTK = ({ shouldLoad = false }: HubSpotUTKProps) => {
  useEffect(() => {
    if (!shouldLoad) return;

    let timerId: number | undefined;

    const onWindowLoad = () => {
      timerId = window.setTimeout(insertHubspotScript, 1000);
    };

    if (document.readyState === 'complete') {
      onWindowLoad();
    } else {
      window.addEventListener('load', onWindowLoad);
    }

    return () => {
      if (timerId !== undefined) {
        window.clearTimeout(timerId);
      }
      window.removeEventListener('load', onWindowLoad);

      const existingScript = document.getElementById('hs-script-loader');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [shouldLoad]);

  return null;
};

export {
  getCookie,
  setCookie,
  isFormRegistrationCookieSet,
  setFormRegistrationCookie,
  FORM_REGISTRATION_CONST,
  HubSpotUTK,
};
